const operatorMap = {
  1: '*',
  2: '/',
  3: '+',
  4: '-',
};

const forecastOptions = [
  { label: "All Channels", value: "all_channels" },
  { label: "Shopify", value: "shopify_channel" },
  { label: "Amazon", value: "amazon_channel" },
  { label: "Wholesale", value: "wholesale_channel" },
]

const monthsFullOptions = [
  { label: "January", value: "jan" },
  { label: "February", value: "feb" },
  { label: "March", value: "mar" },
  { label: "April", value: "apr" },
  { label: "May", value: "may" },
  { label: "June", value: "jun" },
  { label: "July", value: "jul" },
  { label: "August", value: "aug" },
  { label: "September", value: "sep" },
  { label: "October", value: "oct" },
  { label: "November", value: "nov" },
  { label: "December", value: "dec" }
]

const monthsOptions = [
  { label: "Jan", value: "jan" },
  { label: "Feb", value: "feb" },
  { label: "Mar", value: "mar" },
  { label: "Apr", value: "apr" },
  { label: "May", value: "may" },
  { label: "Jun", value: "jun" },
  { label: "Jul", value: "jul" },
  { label: "Aug", value: "aug" },
  { label: "Sep", value: "sep" },
  { label: "Oct", value: "oct" },
  { label: "Nov", value: "nov" },
  { label: "Dec", value: "dec" }
]

const viewForecastOptions = [
  { label: "Selected Product", value: "selected_product" },
  { label: "All Products", value: "all_products" }
];

const monthKeysFullnameEnum = {
    "jan": "January",
    "feb": "February",
    "mar": "March",
    "apr": "April",
    "may": "May",
    "jun": "June",
    "jul": "July",
    "aug": "August",
    "sep": "September",
    "oct": "October",
    "nov": "November",
    "dec": "December",
};

const monthKeysForecastEnum = {
    "jan": "Jan",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "Apr",
    "may": "May",
    "jun": "Jun",
    "jul": "Jul",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "Oct",
    "nov": "Nov",
    "dec": "Dec",
};

const calculateByOperator = (a, b, operator) => {
  switch (operator) {
    case '*':
      return a * b;
    case '/':
      return b !== 0 ? a / b : 0;
    case '+':
      return a + b;
    case '-':
      return a - b;
    default:
      return a;
  }
}

module.exports = {
  operatorMap,
  monthsOptions,
  forecastOptions,
  viewForecastOptions,
  monthsFullOptions,
  monthKeysForecastEnum,
  monthKeysFullnameEnum,
  calculateByOperator
}